export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
          关于红桃影院
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          致力于打造国内领先的综艺在线观看平台
        </p>
        <div className="text-left bg-background-100 rounded-2xl p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            红桃影院是一个专注综艺在线观看的综合性平台，致力于为广大综艺爱好者提供热门综艺、真人秀免费看、
            最新综艺、搞笑综艺等高清内容的在线观看服务。我们收录了数千部国内外综艺节目，涵盖搞笑综艺、
            真人秀、脱口秀、音乐综艺、旅行综艺、推理综艺、恋爱综艺、美食综艺、竞技综艺等多个品类。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            平台坚持"免费综艺，高清在线看"的理念，每日更新热门综艺超过50期，采用先进CDN加速技术保证
            播放流畅不缓冲。无论是电脑、平板还是手机，都能获得优质的综艺在线观看体验。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            红桃影院综艺大全持续扩充内容库，让每一位综艺迷都能在这里找到心仪的节目。每日欢乐不停，
            尽在红桃影院综艺在线观看。
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-3xl font-heading text-primary-500">2019</div>
            <div className="text-xs text-foreground-500 mt-1">平台创立</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-heading text-accent-500">3000+</div>
            <div className="text-xs text-foreground-500 mt-1">综艺资源</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-heading text-secondary-500">500万+</div>
            <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
          </div>
        </div>
      </div>
    </section>
  );
}